var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartnersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24414",
    "data-name": "Rectangle 24414",
    width: 84,
    height: 84,
    transform: "translate(0 -0.308)",
    fill: "#fe6831"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "partners_icon",
    transform: "translate(0 0.308)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75345",
    "data-name": "Path 75345",
    d: "M24.305,44.821l.721.417v4.579l-3.287.822,7.625,4.448-.055,2.673-.117.409,4.51-1V56.094a7.194,7.194,0,0,1,2.07-5.038l-4.961-1.24-.006-4.575.723-.418a7.257,7.257,0,0,0,3.619-6.256V36.04a7.475,7.475,0,0,0-7.006-7.589,7.226,7.226,0,0,0-7.451,7.224v2.891A7.249,7.249,0,0,0,24.305,44.821Z",
    transform: "translate(-9.124 -12.558)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75346",
    "data-name": "Path 75346",
    d: "M42.636,16.132a18.776,18.776,0,0,1,31.888-.085c.058-.058.109-.121.168-.179a10.08,10.08,0,0,1,3.052-2.029L79.383,10,74.77,5.384,70.705,8.03l-.778-.477a21.573,21.573,0,0,0-6.26-2.6l-.891-.215L61.772,0H55.441l-1,4.742-.889.212a21.6,21.6,0,0,0-6.26,2.6l-.778.477L42.445,5.383,37.826,10l1.622,3.867a10.227,10.227,0,0,1,3.188,2.263Z",
    transform: "translate(-16.68 -0.013)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75347",
    "data-name": "Path 75347",
    d: "M0,59.483V85.91l6.205,2.069,5.246-20.985Z",
    transform: "translate(0 -26.244)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75348",
    "data-name": "Path 75348",
    d: "M78.662,42.3a10.151,10.151,0,0,1-4.337-8.3V31.115a10.056,10.056,0,0,1,1.062-4.5,15.892,15.892,0,0,0-28.207.116A10.656,10.656,0,0,1,48.3,31.479v2.527a10.153,10.153,0,0,1-4.339,8.3V43l5.784,1.448L55.53,43V42.3a10.151,10.151,0,0,1-4.337-8.3V31.115A10.122,10.122,0,0,1,61.624,21a10.387,10.387,0,0,1,9.81,10.48v2.527a10.153,10.153,0,0,1-4.339,8.3V43l5.784,1.448L78.662,43Z",
    transform: "translate(-19.387 -7.997)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75349",
    "data-name": "Path 75349",
    d: "M24.413,77.554l-3.3-1.923-5.1,20.385,2.846.948h.121l5.427-19Z",
    transform: "translate(-7.064 -33.365)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75350",
    "data-name": "Path 75350",
    d: "M52.423,51.886a4.334,4.334,0,0,0-3.285,4.209v.428l.829-.184a17.854,17.854,0,0,1,9.264.422l6.545,2.092a9.016,9.016,0,0,1,2.145.307l8.89,2.54H77.7l.357-.188V56.094a4.334,4.334,0,0,0-3.285-4.209l-8.28-2.069-.006-4.575.723-.418a7.257,7.257,0,0,0,3.619-6.256V36.04a7.475,7.475,0,0,0-7.006-7.589,7.226,7.226,0,0,0-7.451,7.224v2.891a7.249,7.249,0,0,0,3.616,6.253l.721.417v4.579Z",
    transform: "translate(-21.669 -12.558)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75351",
    "data-name": "Path 75351",
    d: "M102.955,35.676v2.891a7.25,7.25,0,0,0,3.616,6.253l.722.417v4.579l-4.962,1.24a7.2,7.2,0,0,1,2.07,5.038v3.895l15.9-8.368-7.223-1.8-.006-4.575.723-.418a7.257,7.257,0,0,0,3.619-6.256V36.04a7.475,7.475,0,0,0-7.006-7.589,7.226,7.226,0,0,0-7.451,7.224Z",
    transform: "translate(-45.126 -12.558)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75352",
    "data-name": "Path 75352",
    d: "M57.146,93.632a2.982,2.982,0,0,0-3.467-.334L48.3,96.526a4.842,4.842,0,0,1-7.333-4.154v-.286a4.817,4.817,0,0,1,2.678-4.332l7.22-3.61-2.13-.681a14.9,14.9,0,0,0-7.757-.351l-9.76,2.17L27.321,98.909l4.442,2.665a4.327,4.327,0,0,1,.4-.495l2.541-2.541a4.5,4.5,0,0,1,7.684,3.032,4.5,4.5,0,0,1,4.337,4.337,4.5,4.5,0,0,1,4.337,4.337,4.5,4.5,0,0,1,3.882,2.526l3.227,2.689a2.38,2.38,0,0,0,1.52.551,1.508,1.508,0,0,0,.966-2.666L53.047,107l1.852-2.222,7.853,6.543a1.5,1.5,0,0,0,.964.352h.316A1.508,1.508,0,0,0,65,109.007l-7.613-6.343,1.852-2.223,7.84,6.534a1.556,1.556,0,0,0,.995.361h.25a1.555,1.555,0,0,0,1.041-2.711Z",
    transform: "translate(-12.048 -36.508)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75353",
    "data-name": "Path 75353",
    d: "M81.831,81.847l-2.2-.055-9.085-2.6a6.291,6.291,0,0,0-4.506.418l-8.065,4.032a1.942,1.942,0,0,0-1.08,1.745v.286a1.952,1.952,0,0,0,2.952,1.676l5.386-3.23a5.817,5.817,0,0,1,6.891.664L84.338,95.781c.087.078.169.157.249.242l24.357-12.178V67.577Z",
    transform: "translate(-25.09 -29.814)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75354",
    "data-name": "Path 75354",
    d: "M75.276,143.273a4.473,4.473,0,0,1-.911,1.343L73.28,145.7l1.081.954a1.5,1.5,0,0,0,1,.378h.268a1.508,1.508,0,0,0,.966-2.667Z",
    transform: "translate(-32.315 -63.194)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75355",
    "data-name": "Path 75355",
    d: "M66.231,137.069a1.631,1.631,0,0,0-1.146.475l-2.541,2.541a1.621,1.621,0,0,0,2.293,2.293l2.541-2.541a1.621,1.621,0,0,0-1.146-2.767Z",
    transform: "translate(-27.371 -60.458)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75356",
    "data-name": "Path 75356",
    d: "M52.335,123.173a1.622,1.622,0,0,0-2.767-1.147l-2.541,2.541a1.621,1.621,0,0,0,2.293,2.293l2.541-2.541A1.632,1.632,0,0,0,52.335,123.173Z",
    transform: "translate(-20.528 -53.615)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75357",
    "data-name": "Path 75357",
    d: "M60.093,130.931a1.621,1.621,0,0,0-2.767-1.147l-2.541,2.541a1.621,1.621,0,0,0,2.293,2.293l2.541-2.541A1.633,1.633,0,0,0,60.093,130.931Z",
    transform: "translate(-23.95 -57.036)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75358",
    "data-name": "Path 75358",
    d: "M44.576,115.414a1.621,1.621,0,0,0-2.767-1.146l-2.541,2.541A1.621,1.621,0,0,0,41.56,119.1L44.1,116.56A1.631,1.631,0,0,0,44.576,115.414Z",
    transform: "translate(-17.107 -50.194)",
    fill: "#fe6831"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersIcon);
export default __webpack_public_path__ + "static/media/partners_icon.2d74c8d9aae453e7fb6715e841e74796.svg";
export { ForwardRef as ReactComponent };